<div class="section">
	<particles></particles>
	<div class="row align-items-center minContentHeight text-center">
		<div class="col-sm-6 container">
			<h5 i18n="Modal Titel for SubscriptionConfirmation@@subcription-confirmed.title">ALMOST FINISHED...</h5>
			<div class="innerContainer">
				We just need to confirm your email address, otherwise cannot invite you to the Closed Beta of  <span class="gameName">Arkheim - Realms at war!</span>
				<br/>
				If you do not receive an email within the next hour, please also check your Spam folder.<br/>
				<br/>
				See you on the battlefield!
			</div>
		</div>
	</div>
</div>
